module.exports = __webpack_public_path__ + "static/media/icn-table-add.29bf38ca.svg";